import { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
} from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export function DataDialog({
  title,
  open,
  setOpen,
  children,
  className,
  subTitle,
  isIcon,
  action,
  dialogActions,
  minimizeSpacing,
  onClose,
  disableEscapeKeyDown = true,
  disableBackdropClick = true,
  dialogContentSx,
  disableEnforceFocus,
}: any) {
  useEffect(() => {
    if (!globalThis?.document || disableEnforceFocus) {
      return;
    }
    const body = globalThis.document.body;
    const observer = new MutationObserver(() => {
      body.style.touchAction = body.style.overflow === "hidden" ? "none" : "";
    });
    observer.observe(body, {
      attributes: true,
      attributeFilter: ["style"],
    });
    return () => observer.disconnect();
  }, [disableEnforceFocus]);

  const handleClose = (
    event: {},
    reason: "backdropClick" | "escapeKeyDown",
  ) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return;
    }
    if (disableEscapeKeyDown && reason === "escapeKeyDown") {
      return;
    }
    if (onClose) {
      onClose();
    } else {
      setOpen(false);
    }
  };

  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      open={open}
      className={className}
      onClose={handleClose}
      disableEnforceFocus={disableEnforceFocus}
    >
      <div
        className={`${
          !!action ? "flex align-items-center justify-content-between" : ""
        } ${minimizeSpacing ? "padding-24-bottom-0" : "p-24"}`}
        style={action ? { minWidth: 0 } : undefined}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            color: (theme) => theme.palette.common.black,
            ...(action ? { flex: "1 1 auto", minWidth: 0 } : undefined),
          }}
          id="customized-dialog-title"
        >
          <div
            className="flex align-items-center txt-pre-wrap word-break"
            style={action ? { minWidth: 0 } : undefined}
          >
            {isIcon && (
              <ArrowBackIos
                className="icon-back pointer"
                onClick={() => setOpen(false)}
              />
            )}
            {title}
          </div>
          {!!subTitle && subTitle}
        </DialogTitle>
        {action && <div style={{ flexShrink: 0 }}>{action}</div>}
      </div>
      <DialogContent
        dividers
        sx={{
          ...(minimizeSpacing ? { marginBottom: "0 !important" } : undefined),
          ...(dialogContentSx || {}),
        }}
      >
        {children}
      </DialogContent>
      {dialogActions && (
        <DialogActions sx={{ padding: "0 24px 24px !important" }}>
          {dialogActions}
        </DialogActions>
      )}
    </BootstrapDialog>
  );
}
